export enum FILTRES_TRAITEMENT_SG_NF {
	ID = '@id',
	FICHIER_INTEGRE = 'fichierIntegre',
	TYPE = 'type',
	STATUT = 'statut',
	MATRICULE = 'matricule',
	RECU_ENTRE_LE = 'recuEntreLe',
	ET_LE = 'etLe',
	PAGE = 'page'
}